import Assessment from './Assessment';

export default Assessment;
